import { render, staticRenderFns } from "./LoyaltySettingExclusionsProduct.vue?vue&type=template&id=20285463&scoped=true&"
import script from "./LoyaltySettingExclusionsProduct.vue?vue&type=script&lang=js&"
export * from "./LoyaltySettingExclusionsProduct.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySettingExclusionsProduct.vue?vue&type=style&index=0&id=20285463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20285463",
  null
  
)

export default component.exports